var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3714 2.54855C10.7145 2.28581 10 2.76957 10 3.47703V6H11.5C12.3284 6 13 6.67157 13 7.5V20H15V17.5C15 16.6716 15.6716 16 16.5 16C17.3284 16 18 16.6716 18 17.5V20H20V6.67703C20 6.26813 19.751 5.90042 19.3714 5.74855L11.3714 2.54855ZM16.3162 6.43875C15.6687 6.22291 15 6.70488 15 7.38743V13C15 13.5523 15.4477 14 16 14H17C17.5523 14 18 13.5523 18 13V7.72077C18 7.29034 17.7246 6.9082 17.3162 6.77208L16.3162 6.43875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21C2 20.4477 2.44772 20 3 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C4.44772 8 4 8.44772 4 9V20H6V18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5V20H11V9C11 8.44772 10.5523 8 10 8H5ZM6 11C6 10.4477 6.44772 10 7 10H8C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12H7C6.44772 12 6 11.5523 6 11ZM6 14C6 13.4477 6.44772 13 7 13H8C8.55228 13 9 13.4477 9 14C9 14.5523 8.55228 15 8 15H7C6.44772 15 6 14.5523 6 14Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company_icon.46c6d0baa410801e483c053575f3b1d3.svg";
export { ForwardRef as ReactComponent };